/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterError,
  PresenterNumJournalsOfType,
  PresenterOneExportJournalHistoryResponse,
  PresenterOneJournalResponse,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Journals<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get list journal. For agents: default filter[term_month_id] to current term month, filter[journal_event_type] to 1 when user does not provide it.
   *
   * @tags journals
   * @name GetJournals
   * @summary Get list journal
   * @request GET:/journals
   */
  getJournals = (
    query?: {
      "filter[journal_event_type]"?: (1 | 2 | 3 | 4 | 5 | 6 | 7)[];
      "filter[term_month_id]"?: number;
      sort?: string[];
      "page[number]"?: number;
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneJournalResponse[];
      },
      PresenterError
    >({
      path: `/journals`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get export journal histories in the current MonthlyClosing
   *
   * @tags journals
   * @name GetJournalsExportJournalHistories
   * @summary Get export journal histories in the current MonthlyClosing
   * @request GET:/journals/export_journal_histories
   */
  getJournalsExportJournalHistories = (
    query?: {
      monthly_closing_id?: number;
      /** @min 1 */
      "page[number"?: number;
      /** @min 1 */
      "page[size"?: number;
      type?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneExportJournalHistoryResponse[];
      },
      PresenterError
    >({
      path: `/journals/export_journal_histories`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get export journal histories in the current MonthlyClosing
   *
   * @tags journals
   * @name GetJournalsJournalLinkageHistories
   * @summary Get journal linkage histories in the current MonthlyClosing
   * @request GET:/journals/journal_linkage_histories
   */
  getJournalsJournalLinkageHistories = (
    query?: {
      monthly_closing_id?: number;
      /** @min 1 */
      "page[number"?: number;
      /** @min 1 */
      "page[size"?: number;
      type?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneExportJournalHistoryResponse[];
      },
      PresenterError
    >({
      path: `/journals/journal_linkage_histories`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get total journals of each journal event type
   *
   * @tags journals
   * @name GetJournalsTotal
   * @summary Get total journals of each journal event type
   * @request GET:/journals/total
   */
  getJournalsTotal = (
    query?: {
      "filter[journal_event_type]"?: (1 | 2 | 3 | 4 | 5 | 6 | 7)[];
      "filter[term_month_id]"?: number;
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterNumJournalsOfType;
      },
      PresenterError
    >({
      path: `/journals/total`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
